import React from "react";
import {
    Box,
    Typography,
    Button,
    Container,
    Grid,
    Paper,
    Divider,
    Stack,
    useTheme,
    useMediaQuery,
} from "@mui/material";

import { Link as RouterLink } from "react-router-dom";

// Importações de Assets e Componentes
import Header from "../components/Header"; 
import Footer from "../components/Footer";
import { IoBookOutline } from "react-icons/io5";

import ImageHero from "../assets/bannerPadThai.png";
import IconUaiThai from "../assets/iconUaiThai.png";
import PlateOne from "../assets/polvo.jpg";
import PlateTwo from "../assets/sao_jose.jpeg";
import PlateThree from "../assets/pla.jpg";
import PlateFour from "../assets/costela.jpg";
// Adicione a imagem do Banner Reservas aqui se não estiver importada
import BannerReservas from "../assets/bannerReservas.png";

// --- DEFINIÇÃO DE CORES (Baseado no seu CSS) ---
const colors = {
    offwhite: "#fdfcf5", // Ajuste se seu offwhite for diferente
    azulEscuro: "#071739",
    vermelho: "#e91e21", // Ajuste para o seu tom exato de vermelho
    cinza: "#211f1f",
    textoClaro: "#e5e5e5",
};

const Home = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    // DADOS
    const pratosPrincipais = [
        {
            id: 1,
            nome: "Bora Polvo",
            descricao:
                "Polvo macio e crocante, servido com purê de cenoura, laranja e gengibre. Acompanha ragu de polvo, mexilhões e cebola roxa.",
            imagem: PlateOne,
        },
        {
            id: 2,
            nome: "Serra de São José",
            descricao:
                "Carré de cordeiro com especiarias tailandesas e demi-glace de mexerica. Acompanha cuscuz de quinoa e brotos.",
            imagem: PlateTwo,
        },
        {
            id: 3,
            nome: "Pla The Rath",
            descricao:
                "Truta grelhada em leite de coco e especiarias. Acompanha legumes salteados e arroz de jasmim.",
            imagem: PlateThree,
        },
        {
            id: 4,
            nome: "Costela Hmuyang",
            descricao:
                "Costela suína marinada em especiarias, assada ao forno e servida com redução de melaço. Acompanha farofa de caju e arroz de jasmim.",
            imagem: PlateFour,
        },
    ];

    const depoimentos = [
        {
            id: 1,
            rate: 4,
            nome: "Matheus Silva",
            descricao:
                "Uma experiência gastronômica inesquecível! A combinação dos sabores tailandeses com o toque mineiro é simplesmente divina.",
        },
        {
            id: 2,
            rate: 5,
            nome: "Larissa Mello",
            descricao:
                "O UaiThai Tiradentes é o lugar perfeito para quem busca autenticidade e qualidade. Cada prato é preparado com muito cuidado.",
        },
        {
            id: 3,
            rate: 4,
            nome: "Gustavo Ribeiro",
            descricao:
                "Fiquei encantado com a fusão de sabores entre a culinária tailandesa e mineira. O atendimento foi impecável.",
        },
    ];

    return (
        <>
            <Header />

            {/* --- HERO SECTION --- */}
            <Box
                component="section"
                sx={{
                    position: "relative",
                    width: "100%",
                    height: { xs: "80vh", md: "110vh", sm: "100vh" },
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    // Background Image
                    backgroundImage: `url(${ImageHero})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                {/* Overlay Escuro */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.4)", // Ajuste a opacidade conforme necessidade
                        zIndex: 1,
                    }}
                />

                <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
                    <Box
                        sx={{
                            maxWidth: "600px",
                            display: "flex",
                            flexDirection: "column",
                            transform: { xs: "translateY(0)", md: "translateY(-10%)" },
                            gap: 2,
                            paddingTop: { xs: 4, md: 0 },

                            textAlign: { xs: "left", md: "left" },
                            alignItems: { xs: "left", md: "flex-start" },
                            px: { xs: 2, md: 0 },
                        }}
                    >
                        <Typography
                            variant="h1"
                            sx={{
                                fontSize: { xs: "2rem", md: "3rem" },
                                fontWeight: 700,
                                color: colors.offwhite,
                                lineHeight: 1.2,
                                textShadow: "0 3px 10px rgba(0, 0, 0, 0.5)",
                            }}
                        >
                            O Sabor Autêntico <br />
                            da Tailândia com <br />
                            <Box component="span" sx={{ fontWeight: 800 }}>
                                Toque Mineiro!
                            </Box>
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: { xs: "0.9rem", md: "1.1rem" },
                                color: colors.textoClaro,
                                lineHeight: 1.6,
                                maxWidth: "500px",
                                textAlign: { xs: "left", md: "justify" },
                                display: { xs: "none", md: "block" }
                            }}
                        >
                            Direto da cozinha para sua mesa: aromas intensos, temperos exóticos
                            e a hospitalidade mineira que transforma cada refeição em uma
                            experiência única.
                        </Typography>

                        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={1}>
                            <Button
                                component={RouterLink}
                                to="/reservas"
                                variant="contained"
                                sx={{
                                    backgroundColor: colors.offwhite,
                                    color: colors.azulEscuro,
                                    fontWeight: 700,
                                    py: 1.5,
                                    px: 3,
                                    "&:hover": {
                                        backgroundColor: colors.azulEscuro,
                                        color: colors.offwhite,
                                    },
                                }}
                            >
                                Fazer Reserva
                            </Button>
                            <Button
                              component="a"
                              href="/pdf/cardapio.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                              variant="outlined"
                              startIcon={<IoBookOutline />}
                              sx={{
                                borderColor: colors.offwhite,
                                color: colors.offwhite,
                                borderWidth: "1.8px",
                                fontWeight: 700,
                                py: 1.5,
                                px: 3,
                                "&:hover": {
                                  backgroundColor: colors.offwhite,
                                  color: colors.azulEscuro,
                                  borderColor: colors.offwhite,
                                },
                              }}
                            >
                              Ver Cardápio
                            </Button>
                        </Stack>
                    </Box>
                </Container>

                {/* Gradient Bottom */}
                <Box
                    sx={{
                        display: { xs: "none", md: "block" },
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        height: "160px",
                        background: `linear-gradient(to bottom, rgba(7, 23, 57, 0) 0%, ${colors.offwhite} 100%)`,
                        zIndex: 3,
                    }}
                />
            </Box>

            {/* --- SEÇÃO SOBRE (Card Flutuante) --- */}
            <Box
                component="section"
                sx={{
                    backgroundColor: colors.offwhite,
                    pb: 8,
                    px: 2,
                    position: "relative",
                    zIndex: 5,
                }}
            >
                <Container maxWidth="lg" sx={{ transform: { md: "translateY(-35px)", xs: "translateY(-15px)" }, }}>
                    <Paper
                        elevation={5}
                        sx={{
                            mt: { xs: -5, md: -15 },
                            p: { xs: 3, md: 6 },
                            borderRadius: "16px",
                            textAlign: "center",
                            backgroundColor: colors.offwhite,
                            transition: "transform 0.3s ease",
                            "&:hover": {
                                transform: "translateY(-3px)",
                            },
                        }}
                    >
                        <Typography
                            variant="h2"
                            sx={{
                                fontSize: { xs: "1.6rem", md: "2rem" },
                                fontWeight: 800,
                                color: colors.cinza,
                                mb: 2,
                            }}
                        >
                            UaiThai Tiradentes
                        </Typography>

                        {/* Divider customizado */}
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            spacing={2}
                            sx={{ width: { xs: "100%", md: "50%" }, mx: "auto", mb: 3 }}
                        >
                            <Divider sx={{ flex: 1, backgroundColor: "#e4e3de", height: 2 }} />
                            <img src={IconUaiThai} alt="Ícone UaiThai" style={{ height: "30px" }} />
                            <Divider sx={{ flex: 1, backgroundColor: "#e4e3de", height: 2 }} />
                        </Stack>

                        <Typography sx={{ color: colors.cinza, mb: 2, textAlign: "justify", fontSize: "1.05rem" }}>
                            Descubra por que o UaiThai Tiradentes é o lugar ideal para
                            transformar sua refeição em um momento memorável. Localizado no
                            coração de Tiradentes, unimos a tradição milenar da gastronomia
                            tailandesa com o toque acolhedor da culinária mineira.
                        </Typography>

                        <Typography sx={{ color: colors.cinza, mb: 4, textAlign: "justify", fontSize: "1.05rem" }}>
                            Aqui, cada detalhe importa: ingredientes frescos, receitas
                            autênticas e um ambiente encantador. Mais que um restaurante, o
                            UaiThai é uma experiência gastronômica inesquecível.
                        </Typography>

                        <Button
                            component={RouterLink}
                            to="/nossa-historia"
                            variant="contained"
                            sx={{
                                backgroundColor: colors.azulEscuro,
                                fontWeight: 700,
                                px: 4,
                                py: 1.5,
                                borderRadius: "6px",
                                "&:hover": { backgroundColor: colors.vermelho },
                            }}
                        >
                            Nossa História
                        </Button>
                    </Paper>
                </Container>
            </Box>

            {/* --- SEÇÃO PRATOS PRINCIPAIS --- */}
            <Box
                component="section"
                sx={{
                    py: { xs: 0, md: 0 },
                    backgroundColor: colors.offwhite,
                }}
            >
                    

                <Container maxWidth="lg">
                    <Typography
                        variant="h2"
                        sx={{
                            fontSize: { xs: "1.8rem", md: "2rem" },
                            fontWeight: 600,
                            color: colors.cinza,
                            mb: { xs: 3, md: 4 },
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                    Pratos Principais
                </Typography>
                </Container>

                <Container maxWidth="xl">

                    <Grid container spacing={{ xs: 3, md: 4 }} sx={{ mb: { xs: 4, md: 6 }, display: "flex", justifyContent: "center" }}>
                        {pratosPrincipais.map((prato) => (
                            <Grid item xs={12} sm={6} md={3} key={prato.id}>
                                <Paper
                                    elevation={2}
                                    sx={{
                                        p: 3,
                                        width: 280,
                                        borderRadius: "16px",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: "0 6px 25px rgba(0, 0, 0, 0.12)",
                                        },
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={prato.imagem}
                                        alt={prato.nome}
                                        sx={{
                                            width: 120,
                                            height: 120,
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            mb: 2,
                                            alignSelf: { xs: "center", md: "flex-start" },
                                        }}
                                    />

                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 600,
                                            color: colors.cinza,
                                            mb: 1,
                                            textAlign: "left",
                                        }}
                                    >
                                        {prato.nome}
                                    </Typography>

                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#333",
                                            lineHeight: 1.5,
                                            textAlign: "left",

                                        }}
                                    >
                                        {prato.descricao}
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "center", md: "center" },
                        }}
                    >
                        <Button
                          component="a"
                          href="/pdf/cardapio.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          variant="contained"
                          startIcon={<IoBookOutline />}
                          sx={{
                            backgroundColor: colors.azulEscuro,
                            fontWeight: 700,
                            px: 3,
                            py: 1.5,
                            mb: 8,
                            borderRadius: "8px",
                            "&:hover": { backgroundColor: colors.vermelho },
                          }}
                        >
                          Nosso Cardápio
                        </Button>
                    </Box>
                </Container>
            </Box>

            {/* --- SEÇÃO RESERVAS (Banner) --- */}
            <Box
                component="section"
                sx={{
                    py: { xs: 6, md: 10 },
                    backgroundImage: `linear-gradient(rgba(7, 23, 57, 0.4), rgba(7, 23, 57, 0.1)), url(${BannerReservas})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundColor: colors.azulEscuro,
                    color: colors.offwhite,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    gap: 3,
                }}
            >
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    alignItems="center"
                    justifyContent="center"
                    width="100%"
                    spacing={2}
                >
                    <Divider sx={{ width: { xs: "50%", md: "25%" }, bgcolor: colors.offwhite, height: 2 }} />
                    <Button
                        component={RouterLink}
                        to="/reservas"
                        variant="contained"
                        sx={{
                            backgroundColor: colors.offwhite,
                            color: colors.azulEscuro,
                            fontWeight: 700,
                            px: 4,
                            py: 1.5,
                            "&:hover": { backgroundColor: "#e0e0e0" },
                        }}
                    >
                        RESERVE AGORA
                    </Button>
                    <Divider sx={{ width: { xs: "50%", md: "25%" }, bgcolor: colors.offwhite, height: 2 }} />
                </Stack>

                <Box>
                    <Typography variant="h6" fontWeight="bold">Horário de Funcionamento:</Typography>
                    <Typography variant="body1">
                        Terça a Domingo: 13h às 15h30 / Terça a Sábado: 19h às 22h30
                    </Typography>
                </Box>
            </Box>

            <Box component="section" sx={{ py: { xs: 6, md: 8 }, backgroundColor: colors.offwhite }}>

                <Container maxWidth="lg">
                    <Typography
                        variant="h2"
                        sx={{
                            fontSize: { xs: "1.8rem", md: "2rem" },
                            fontWeight: 600,
                            color: colors.cinza,
                            mb: { xs: 3, md: 4 },
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                        Nossos Clientes
                    </Typography>
                </Container>

                <Container maxWidth="xl">

                    <Grid
                        container
                        spacing={{ xs: 3, md: 4 }}
                        sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        {depoimentos.map((depoimento) => (
                            <Grid item xs={12} sm={6} md={4} key={depoimento.id} >
                                <Paper
                                    elevation={2}
                                    sx={{
                                        p: 4,
                                        borderRadius: "12px",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        width: { xs: "100%", sm: 250, md: 380 },
                                    }}
                                >
                                    <Box>
                                        <Typography variant="h6" sx={{ fontWeight: 700, mb: 0, textAlign: "left" }}>
                                            {depoimento.nome}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: colors.azulEscuro,
                                                fontSize: "1.4rem",
                                                mb: 0,
                                                textAlign: "left",
                                            }}
                                        >
                                            {"★".repeat(depoimento.rate)}
                                        </Typography>
                                    </Box>

                                    <Typography color="text.secondary" sx={{ textAlign: "left", fontSize: "0.95rem", mt: 2 }}>
                                        “{depoimento.descricao}”
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            <Footer />
        </>
    );
};

export default Home;